// extracted by mini-css-extract-plugin
module.exports = {"container":"_3qTQTy mz-price-breakdown__item zmNIBl","icon":"_1nwDyi"};